"use client";

import AppErrorBoundary from "@/shared/components/AppErrorBoundary";
import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return <AppErrorBoundary error={error} reset={reset} />;
}
